<template>
  <div class="video-layout" @click.stop>
    <basis-nav
      :nav-title="navTitle"
      :back="back"
    />
    <!-- 基本信息 -->
    <div class="info">
      <p class="title">{{ item.title }}</p>
      <span class="teacher">老师：{{ activeTeacher.name }}</span>
    </div>
    <!-- 单字左右切换 -->
    <div class="operate-wrapper">
      <span v-if="item.prev && item.prev.id" class="operate prev" @click="turnPageHandler(item.prev.id)">
        <van-icon name="arrow-left" /> {{ item.prev.title }}
      </span>
      <span v-if="item.next && item.next.id" class="operate next" @click="turnPageHandler(item.next.id)">
        {{ item.next.title }} <van-icon name="arrow" />
      </span>
    </div>
    <!-- 内容填充 -->
    <div class="video-content">
      <slot />
    </div>
    <div class="footer-wrapper">
      <!-- 点爱心 + 分享 -->
      <div class="right-operate">
        <div class="icon-wrapper" @click="toggoleStarHandler">
          <van-icon name="like" :class="['like', {star}]" />
          <!-- <p class="count">{{ item.staringCount	}}</p> -->
        </div>
        <div class="icon-wrapper" @click="isShowShare = true">
          <van-icon name="share" class="share" />
          <!-- <p class="count">{{ item.forwardingCount }}</p> -->
        </div>
      </div>
      <div class="des-wrapper" @click.stop="isShowDesc = true">
        <div class="des" v-html="item.caption" />
        <span class="more">查看全部</span>
      </div>
      <div class="operating">
        <!-- 知讯介绍 -->
        <van-popup
          v-model="isShowDesc"
          round
          position="bottom"
          class="video-desc"
        >
          <p class="title">{{ item.category }}简介</p>
          <div class="des-detail" v-html="item.caption" />
        </van-popup>
        <!-- 分享操作 -->
        <van-overlay
          class="share"
          :show="isShowShare"
          @click="isShowShare = false"
        >
          <div class="share-image">
            <span class="label">
              点击右上角<br>
              分享给朋友
            </span>
          </div>
        </van-overlay>
      </div>
    </div>
  </div>
</template>

<script>
import { BasisNav } from '@/components/basis'
import { Stars } from '@/api'
import { mapGetters } from 'vuex'

export default {
  name: 'VideoLayout',
  components: { BasisNav },
  props: {
    navTitle: {
      type: String,
      required: true,
      default: ''
    },
    item: {
      type: Object,
      required: true,
      default: () => {}
    },
    back: {
      type: Function,
      required: true
    }
  },
  data: () => ({
    isShowDesc: false,
    isShowShare: false,
    mode: false,
    star: false
  }),
  computed: {
    ...mapGetters(['teacher']),
    activeTeacher () {
      return this.item.teacher || this.teacher || {}
    },
    collection () {
      const { name } = this.$route
      return name.split('-')[0]
    },
    id () {
      const { id } = this.$route.params
      return id
    }
  },
  watch: {
    '$route.params.id': {
      handler (newId, oldId) {
        if (newId !== oldId) {
          this.getStar()
        }
      }
    }
  },
  async mounted () {
    this.getStar()
  },
  methods: {
    async getStar () {
      try {
        const { star } = await Stars.checkStar({ collection: this.collection, resourceId: this.id })
        this.star = star
      } catch (error) {
        console.log(error)
      }
    },
    async toggoleStarHandler () {
      try {
        switch (this.star) {
          case true: // 取消收藏
            await Stars.deleteStar({ collection: this.collection, resourceId: this.id })
            this.star = false
            break
          case false: // 加入收藏
            await Stars.addStar({ collection: this.collection, resourceId: this.id })
            this.star = true
            break
        }
      } catch (error) {
        console.log(error)
      }
    },
    turnPageHandler (id) {
      this.$router.replace({
        params: {
          id
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.video-layout {
  @include wh(100%, 100vh);
  display: flex;
  flex-direction: column;
  position: relative;
  background-color: #000;
  .basis-nav {
    width: 100%;
    ::v-deep {
      .van-nav-bar  {
        color: #fff;
        background-color: transparent;
        &::after {
          border-color: transparent;
        }
        .left-icon {
          @include sc(22px, inherit);
        }
        .van-nav-bar__text, .van-icon-arrow-left {
          @include sc($font-size-lg, #fff);
        }
        .van-nav-bar__title {
          @include sc($font-size-xlg, #fff);
        }
      }
    }
  }
  .info {
    padding: 4px 0;
    text-align: center;
    .title {
      @include sc($font-size-lg, #fff);
      @include lw(23px, 400);
      margin-bottom: 2px;
    }
    .teacher {
      @include sc($font-size-base, #fff);
      @include lw(17px, 400);
      opacity: 0.8;
    }
  }
  .operate-wrapper {
    overflow: hidden;
    @include sc($font-size-base, #fff);
    .operate {
      padding: 0 18px 10px;
      z-index: 99;
      &.prev, &.next {
        display: inline-flex;
        align-items: center;
      }
      &.prev {
        float: left;
      }
      &.next {
        float: right;
      }
      .van-icon {
        vertical-align: middle;
      }
    }
  }
  .video-content {
    height: 100%;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .footer-wrapper {
    position: fixed;
    background: rgba($color: #000000, $alpha: .8);
    left: 0;
    bottom: 0;
    @include wh(100%, 130px);
    .right-operate {
      position: absolute;
      bottom: 40px;
      right: 16px;
      z-index: 99;
      .icon-wrapper {
        & + .icon-wrapper {
          margin-top: 12px;
        }
        .van-icon {
          @include sc(30px, #fff);
          &.like{
            &.star {
              color: $color-text-active;
            }
          }
        }
        .count {
          @include sc($font-size-lg, #fff);
          @include lw(22px, 400);
          text-align: center;
        }
      }
    }
    .des-wrapper {
      @include sc($font-size-base, #fff);
      padding-right: 40px;
      position: absolute;
      left: 16px;
      right: 16px;
      bottom: 40px;
      .des {
        @include ellipsis(2, 17px);
        height: 34px;
      }
      .more {
        color: $color-text-active;
      }
    }
    .operating {
      .video-desc {
        height: 60%;
        .title {
          @include wh(100%, 48px);
          @include lw(48px, 500);
          @include sc($font-size-lg, $color-text-heavy);
          text-align: center;
          border: 1px solid #E8EAEB;
        }
        .des-detail {
          padding: 16px;
          white-space: pre-line;
        }
      }
      .share {
        z-index: 999;
        .share-image {
          @include wh(100vw, 100vh);
          background: url('~@/assets/images/video/share.png') no-repeat;
          background-position: top 10px right 25px;
          background-size: 162px 230px;
          position: relative;
          .label {
            @include sc($font-size-lg, #fff);
            @include lw(22px, 400);
            letter-spacing: 1px;
            position: absolute;
            left: 100px;
            top: 250px;
            &::after {
              @include wh(26px, 26px);
              @include sc($font-size-xlg, #000);
              @include lw(16px, 600);
              content: "...";
              border-radius: 50%;
              background-color: #fff;
              text-align: center;
              vertical-align: top;
              position: absolute;
              right: -32px;
              top: 0;
            }
          }
        }
      }
    }
  }
}
</style>
